import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Skeleton, Tab, Tabs } from "@mui/material";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";
import classNames from "classnames";
import { Icons } from "assets";
import { routeConstant } from "shared/routes/routesConstant";
import { useNavigate } from "react-router-dom";
import { pendingTasksCounterListings } from "shared/services/projectHeadService";
import { roles } from "shared/utils/constants";
import moment from "moment";

const tabs = [
  {
    value: 0,
    label: "Product Manager",
    counter: 5,
    role_id: roles.productManager,
    navigate: routeConstant.pendingTasks.path.replace(":keyword", "manager"),
    keyword: "product_manager",
  },
  {
    value: 1,
    label: "HOD Content",
    counter: 8,
    role_id: roles.hod,
    navigate: routeConstant.pendingTasks.path.replace(":keyword", "hod"),
    keyword: "hod_content",
  },
  {
    value: 2,
    label: "Admin",
    counter: 6,
    role_id: roles.admin,
    navigate: routeConstant.pendingTasks.path.replace(":keyword", "admin"),
    keyword: "admin",
  },
  {
    value: 3,
    label: "Accountant",
    counter: 24,
    role_id: roles.accountant,
    navigate: routeConstant.pendingTasks.path.replace(":keyword", "accountant"),
    keyword: "accountant",
  },
];

export default function PendingTaskGrid() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [pendingTasks, setPendingTasks] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [allCounts, setAllCounts] = useState<any>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  ////

  const getTasksList = () => {
    setLoader(true);
    pendingTasksCounterListings(
      Number(tabs?.find((item: any) => activeTab === item?.value)?.role_id),
      {
        from: moment(startDate).format("YYYY-MM-DD"),
        to: moment(endDate).format("YYYY-MM-DD"),
      }
    )
      .then(({ data }) => {
        setLoader(false);
        setPendingTasks(data?.data?.details);
        setAllCounts(data?.data?.all_counts);
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getTasksList();
    }
    //eslint-disable-next-line
  }, [activeTab, endDate]);

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.topContainer}>
        <div className={styles.headingContainer}>
          <div className={styles.heading}>Pending Task of Admin Accounts</div>
          <div className={styles.subHeading}>
            you can view the pending task number of admin roles
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </Box>
      <Box>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          className={styles.tab}
          TabIndicatorProps={{
            style: {
              backgroundColor: "black",
            },
          }}
        >
          {tabs?.map((item: any, index: any) => {
            let count_key;

            if (allCounts && typeof allCounts === "object") {
              count_key = Object.keys(allCounts)?.find(
                (itm) => itm === item?.keyword
              );
            }
            return (
              <Tab
                label={
                  <div
                    className={classNames(
                      styles.tabs,
                      activeTab === item?.value && styles.active
                    )}
                  >
                    <label className={styles.tabLabel}> {item?.label}</label>
                    <label className={styles.tabCounter}>
                      {count_key !== undefined ? allCounts[count_key] : 0}
                    </label>
                  </div>
                }
              />
            );
          })}
        </Tabs>
      </Box>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none" }}
        className={styles.tableContainer}
      >
        <Table aria-label="simple table">
          <TableHead className={styles.tableHead}>
            <TableRow>
              <TableCell>Tasks Title</TableCell>
              <TableCell>No of Tasks</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {loader ? (
              <Loader />
            ) : (
              pendingTasks?.map((item: any, index: any, arr: any) => {
                return (
                  <TableRow
                    className={classNames(
                      index + 1 === arr.length && styles.lastCells
                    )}
                  >
                    <TableCell sx={{ maxWidth: "200px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <div>
                          <Icons.CheckCricle
                            style={{ height: "20px", width: "20px" }}
                          />
                        </div>
                        <label>{item?.title}</label>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={styles.requests}>
                        {item?.count} Requests
                      </div>
                    </TableCell>
                    <TableCell
                      className={styles.viewDetails}
                      onClick={() => {
                        navigate(
                          tabs[activeTab].navigate.replace(":task", "task")
                        );
                      }}
                    >
                      View Details
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

const Loader = () => {
  return (
    <>
      {Array.from({ length: 5 }).map((item, index) => {
        return (
          <TableRow className={styles.loadingRow}>
            <TableCell>
              <Skeleton variant="rounded" width={200} height={10} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};
